import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-documents-pdf-icon',
  templateUrl: './documents-pdf.component.html'
})
export class DocumentsPdfComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
